define('frontend-common-components/objectStorageConfig/js/models/objectStorageConfig',[
    './base/baseModel'
],
function (BaseModel) {
    'use strict';
    return BaseModel.extend({
        parse: function (response) {
            return response.length > 0 ? response[0] : response;
        }
    });
});
